import { useState, useEffect } from 'react';
import { Flex, Heading, Alert } from '@instructure/ui';
import RoomList from './RoomList';
import useAppStore from '../../stores/app';
import { getRooms } from '../../lib/api';
import PageLoader from '../../helpers/loader';
const Rooms = () => {
  const { setRoomSid } = useAppStore();
  const [rooms, setRooms] = useState([]);
  const [roomsLoaded, setRoomsLoaded] = useState(false);
  const [locations, setLocations] = useState([]);
  const [expandByDefault, setExpandByDefault] = useState(false);

  useEffect(() => {
    const loadRooms = async () => {
      const roomResult = await getRooms();
      if (roomResult.successful) {
        setRooms(roomResult.data.rooms);
        setLocations(roomResult.data.locations);
        // if there is only one room, expand the toggle group by default...
        if (roomResult.data.locations.length === 1) {
          setExpandByDefault(true);
        }
      } else {
        // TODO: Add error handling
      }
      setRoomsLoaded(true);
    };
    loadRooms();
  }, []);

  return (
    <>
      {roomsLoaded ? (
        <Flex
          as="div"
          justifyContent="center"
          alignItems="center"
          height="100vh"
          width="100vw"
          background="secondary"
          withVisualDebug={false}
        >
          <Flex.Item shouldShrink shouldGrow>
            <Flex
              withVisualDebug={false}
              wrap="wrap"
              width="800px"
              justifyItems="space-around"
              margin="0 auto"
            >
              <Heading>Proctor Rooms</Heading>
              <Flex.Item as="div" padding="small" width="100%">
                {locations.length > 0 ? (
                  <RoomList locations={locations} rooms={rooms} />
                ) : (
                  <Alert variant="info" margin="small">
                    This account has no rooms to join.
                  </Alert>
                )}
              </Flex.Item>
            </Flex>
          </Flex.Item>
        </Flex>
      ) : (
        <PageLoader text="Loading rooms..." />
      )}
    </>
  );
};

export default Rooms;
